<template>
  <b-form ref="form" >
    <div class="row">
      <div class="row col-12 pr-0 mb-3">
        <span>Your changes will be lost ! Make sure you save the data before proceeding to the {{ parameters.is_next ? 'next' : 'previous' }} job</span>
      </div>
    </div>
  </b-form>
</template>

<script>

export default {
  components: {
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      model: {
      }
    }
  }
}
</script>